module.exports = __webpack_public_path__ + "media/newstyle/images/authorfreely_primarylogo-3cc28ea3534a8122bb0f3e372243a61a.png";